<ng-container *ngIf="dialogLoaded">
  <div class="dialog-layout">
    <div class="dialog-layout-header" *ngIf="!showDelete">
      <h2>{{ 'APP.ACTIONS.UPLOAD_NOTIFICATION.HEADER' | translate }}</h2>
    </div>
    <div class="dialog-layout-header" *ngIf="showDelete">
      <h2 *ngIf="!fileTypes.isMedia || fileTypes.isMediaAndDoc">
        {{ 'APP.ACTIONS.DELETE_NOTIFICATION.HEADER_DOCUMENT' | translate }}
      </h2>
      <h2 *ngIf="fileTypes.isMedia || fileTypes.isMediaAndDoc">
        {{ 'APP.ACTIONS.DELETE_NOTIFICATION.HEADER' | translate }}
      </h2>
    </div>
    <div class="dialog-layout-body">
      <ng-container *ngIf="!multipleFiles">
        <span class="dialog-layout-body-content" *ngIf="!showDelete">
          {{ 'APP.ACTIONS.UPLOAD_NOTIFICATION.SINGLE_FILE' | translate }}
        </span>
        <div class="dialog-layout-body-single" *ngIf="!showDelete">
          <span
            class="dialog-layout-body-single-link single-link-name"
            (click)="takeToPreview(duplicates[0].id)"
            (keyup)="takeToPreview(duplicates[0].id)"
          >
            <span
              title="{{ getUrlPreview(duplicates[0].id) }}"
              class="dialog-layout-body-single-link-name"
              >{{ duplicates[0].name | clipName }}</span
            >
          </span>
        </div>
      </ng-container>
      <ng-container *ngIf="multipleFiles">
        <span class="dialog-layout-body-content" *ngIf="!showDelete">
          {{ 'APP.ACTIONS.UPLOAD_NOTIFICATION.SINGLE_FILE' | translate }}
        </span>
        <span class="dialog-layout-body-content" *ngIf="showDelete">
          {{ 'APP.ACTIONS.DELETE_NOTIFICATION.MULTIPLE_FILES' | translate }}
        </span>
        <div
          class="dialog-layout-body-multiple"
          *ngIf="!showDelete"
          [ngClass]="{'scroll-multiple-files':duplicates.length>10}"
        >
          <ng-container *ngFor="let duplicate of duplicates">
            <span class="dialog-layout-body-multiple-body">
              <span
                class="dialog-layout-body-multiple-body-link single-link-name"
                (click)="takeToPreview(duplicate.id)"
                (keyup)="takeToPreview(duplicate.id)"
              >
                <span
                  title="{{ getUrlPreview(duplicate.id) }}"
                  class="dialog-layout-body-multiple-body-link-name"
                  >{{ duplicate.name | clipName }}</span
                >
              </span>
            </span>
          </ng-container>
        </div>
        <div
          class="dialog-layout-body-multiple"
          *ngIf="showDelete"
          [ngClass]="{'scroll-multiple-files':associatedFiles.length>10}"
        >
          <ng-container *ngFor="let assc in associatedFiles">
            <span class="dialog-layout-body-multiple-body">
              <span
                class="dialog-layout-body-multiple-body-link single-link-name"
                (click)="takeToPreview(assc.docId)"
                (keyup)="takeToPreview(assc.docId)"
              >
                <span
                  title="{{ getUrlPreview(assc.docId) }}"
                  class="dialog-layout-body-multiple-body-link-name"
                  >{{ assc.name }}</span
                >
              </span>
            </span>
          </ng-container>
        </div>
      </ng-container>
    </div>
    <div class="dialog-layout-action">
      <button class="wk-button" (click)="closeDialog()">
        {{ 'APP.ACTIONS.UPLOAD_NOTIFICATION.OK' | translate }}
      </button>
    </div>
  </div>
</ng-container>
